import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default function () {
  gsap.registerPlugin(ScrollTrigger);

	gsap.utils.toArray('.project').forEach((project) => {
		const wrapImage = project.querySelector('.project-image-wrap');

		gsap.set(project, { yPercent: 0 });

		gsap
			.timeline({
				scrollTrigger: {
					trigger: project,
					start: 'top bottom+=50%',
					end: 'bottom top',
					scrub: 3,
				},
			})
			.to(wrapImage, {
				yPercent: 10,
				ease: 'none',
			});
	});
}
